import { DeliveryDetails, EmailFlowLogDetails } from "@dashboard-v3/api";
import apiRequest from "utils/apiRequestWithErrorCode";

export function getPostfixCodeFromEvent(event: EmailFlowLogDetails) {
  const { serverResponse } = event.data;
  if (!serverResponse) return null;

  const parts = /queued as (.*)[\\n]?$/gm.exec(serverResponse as string);
  if (!parts || parts.length < 2) return null;
  return parts[1];
}

type GetDeliveryInfoParams = {
  event: EmailFlowLogDetails;
  recipient: string;
  code: string;
};

export const fetchDeliveryDetails = async (params: GetDeliveryInfoParams) => {
  const { event, recipient, code } = params;
  const ts = event.createdAt;
  const urlParams = new URLSearchParams();
  urlParams.append("code", code);
  urlParams.append("ts", ts.toString());
  urlParams.append("recipient", recipient);
  const url = `/emailflow-logs/delivery-details?${urlParams.toString()}`;

  return apiRequest<DeliveryDetails[]>("GET", url);
};
